module.exports = __webpack_public_path__ + "images/psp/FeaturedContentImages/man-and-woman-moving-boxes-on-cart-to-a-storage-unit-scaled.webp";